<template>
  <div id="photos_title_banner_component" class="text-white mt-2">
    <div 
      id="photos-content-row"
      class="text-center position-relative">
      <PhotoListHome
        :photos="photos"
        :isLoading="apiStatus === STATUS_API_CALL.RUNNING" />
      <div
        v-if="apiStatus === STATUS_API_CALL.RUNNING && photos.length === 0">
        <div
          class="alert alert-info mt-4 fs-6 fw-bold pt-2 pb-2 w-50 margins-left-right-auto align-middle d-flex justify-content-center align-items-center"
          role="alert">
          <span class="spinner-border text-info fw-bold" role="status"></span>
          <div class="ms-2">{{ languageStore.text(TEXT_KEYS.PHOTO_RESULTS_LOADING_PHOTO)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import PhotoListHome from "@/components/PhotoListHome.vue"

import { useCategoryStore } from "@/stores/category";
import { usePhotoStore } from "@/stores/photo";
import { useLanguageStore } from "@/stores/language"

import {
  STATUS_API_CALL,
  TEXT_KEYS } from '@/constants'

import { PhotoApi } from "@/api/photo-api"

@Options({
  components: {
    PhotoListHome
  }
})
export default class PhotosHome extends Vue {
  categoryStore = useCategoryStore()
  photoStore = usePhotoStore()
  languageStore = useLanguageStore()

  photoIdSelected = -1

  TEXT_KEYS = TEXT_KEYS
  STATUS_API_CALL = STATUS_API_CALL

  apiStatus = STATUS_API_CALL.IDLE

  photos: Record<string, any>[] = []

  api = new PhotoApi()

  mounted() {
    console.log("PhotosHome")

    this.getPhotos()
  }

  async getPhotos() {
    console.log("getPhotos")

    try {
      this.photos = []

      this.apiStatus = STATUS_API_CALL.RUNNING

      const response: any = await this.api.getHome()
      console.log('data', response)

      this.photos = response.data
    } catch(error) {
      console.error('getPhotos', error)

      this.apiStatus = STATUS_API_CALL.FAILED
    } finally {
      this.apiStatus = STATUS_API_CALL.IDLE
    }
  }
}
</script>

<style lang="stylus">
#photos-content-row {
  margin-left: auto
  margin-right: auto
  min-height: 30rem
}

</style>
